import { BrandMark } from '@/components/icons';

/**
 * The app's one piece of persistent, shared chrome: the Debdeep's
 * Ledger brand mark paired with the wordmark, shown once at the top of
 * every screen. This is the "appropriate shared/app-level branding
 * location" for Concept 26 — not repeated on individual cards/sections,
 * and not a splash screen.
 */
export function AppHeader() {
  return (
    <header className="app-header">
      <BrandMark size={26} className="brand-mark" />
      <p className="brand-wordmark">Debdeep&rsquo;s Ledger</p>
    </header>
  );
}
